import {initWebComponent} from "@/helpers/web-component-helper";
import {initDatePicker, initTimePicker} from "@/helpers/date-picker-helper";
import {checkDependentFields} from "@/helpers/form-dependent-helper";
import {setInfoValue} from "@/helpers/info-overview-helper";

const template = document.createElement('template');

export class FormCheckboxComponent extends HTMLElement {
    constructor() {
        super();
        const attributeID = this.getAttribute('data-attribute-id')
        const name = this.getAttribute('data-name')
        const isRequired = this.getAttribute('data-is-required')
        const key = this.getAttribute('data-key')

        const domainList = window.domainListItems[key]
        const wizardItem = window.wizardItem[key]

        template.innerHTML = `
         <h2 class="text-primary">${name} ${isRequired}</h2>
         <div class="form-group text-primary mb-4">
            <div class="list-group mt-2">
                <a class="list-group-item list-group-item-action" data-toggle="list" href="#" data-value="${domainList[0].Value}">
                    <div style="margin-top:3px">${domainList[0].Name}</div>   
                </a>
            </div>
            <div class="list-group mt-2">
                <a class="list-group-item list-group-item-action" data-toggle="list" href="#" data-value="${domainList[1].Value}">
                    <div style="margin-top:3px">${domainList[1].Name}</div>   
                </a>
            </div>
            <small class="invalid-feedback">
                Dit veld is verplicht
            </small>
         </div>
`

        initWebComponent(this, template)

        this.addEventListener('click', clickElement)

        // Wait for other forms to load
        setTimeout(() => {
            if(wizardItem.DefaultValue) {
                clickElement(this.querySelector(`[data-value="${wizardItem.DefaultValue}"]`))
            }
        }, 10)

        function clickElement(e) {

            let element = e.target
            if(!e.target) {
                element = e
            }

            element.closest('form-element').querySelectorAll('.list-group-item-action').forEach((element) => {
                element.classList.remove('active')
            })

            element.closest('.list-group-item-action').classList.add('active')

            checkDependentFields(element, element.closest('.list-group-item-action').dataset.value)
        }
    }
}
